<div class="flex justify-end items-center my-8">
  <mat-slide-toggle
    *ngIf="calibration?.additionalResultsSet"
    color="primary"
    class="my-16 mx-8"
    [(ngModel)]="toggleAlternateCertificate"
  >
    {{ !toggleAlternateCertificate ? "First Result Set" : "Second Result Set" }}
  </mat-slide-toggle>
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="printCalibrationForm()"
  >
    Print
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 mx-8"
    (click)="emailCalibrationForm()"
  >
    Email
  </button>
  <button
    mat-flat-button
    color="primary"
    class="my-16 ml-8 mr-32"
    (click)="openPDF()"
  >
    Download
  </button>
</div>

<div class="flex flex-col p-16 mb-6 border" id="print-section">
  <div>
    <img class="w-full" src="../../../assets/dlm-images/dlm/dlm-header.png" />
  </div>
  <div class="flex justify-center my-16 w-full">
    <h1 style="font-size: 22px !important;">
      CERTIFICATE OF CALIBRATION IN {{ getIsCompressionText() }}
    </h1>
  </div>

  <div class="flex flex-col general-details-container my-16 w-full">
    <div class="flex flex-row items-stretch w-full">
      <div class="top title cell px-8">Customer</div>
      <div class="top data cell px-8">
        {{ loadcell.form10a.thirdPartyCalibrationClient || loadcell.loadcell.customerName }}
      </div>

      <div class="top title cell px-8">Certificate Number</div>
      <div class="top data cell px-8">
        {{ getCertificateNumber() }}
      </div>
    </div>
    <div class="flex flex-row items-stretch w-full">
      <div class="title cell px-8">Calibrated On</div>
      <div class="data cell px-8">
        {{ calibration.date | date: "dd/MM/yyyy" }}
      </div>

      <div class="title cell px-8">Recalibration Due</div>
      <div class="data cell font-red px-8">
        {{ calibration.recalibrationDue | date: "dd/MM/yyyy" }}
      </div>
    </div>
    <div class="flex flex-row items-stretch w-full">
      <div class="title cell px-8">Customer Code</div>
      <div class="data cell px-8">{{ loadcell.customerCode }}</div>

      <div class="title cell px-8">Customer Order</div>
      <div class="data cell px-8">{{ loadcell?.form10a?.purchaseOrder }}</div>
    </div>
    <div class="flex flex-row items-stretch w-full">
      <div class="title cell px-8">DLM Job Number</div>
      <div class="data cell px-8">
        {{ loadcell.loadcell.loadcellId }}
      </div>

      <div class="title cell px-8">Customer Reference</div>
      <div class="data cell px-8">
        {{ calibration.customerRef }}
      </div>
    </div>
  </div>

  <!-- Loadcell Details -->
  <div class="flex flex-col loadcell-details-container my-16 w-full">
    <p class=" mb-4">Loadcell Details</p>

    <div class="flex flex-row items-stretch w-full">
      <div class="top title cell px-8">Manufacturer</div>
      <div class="top data cell px-8">
        {{ loadcell.form10a.manufacturer }}
      </div>

      <div class="top title cell px-8">Plant Id</div>
      <div class="top data cell px-8">
        {{ loadcell.form10a.plantId }}
      </div>
    </div>

    <div class="flex flex-row items-stretch w-full">
      <div class="title cell px-8">Product Type</div>
      <div class="data cell px-8">
        {{ loadcell.form10a.loadCellType?.name }}
      </div>

      <div class="title cell px-8">Proof Load</div>
      <div class="data cell px-8">
        {{ calibration.proofLoad * 100 + "%" }}
      </div>
    </div>
    <div class="flex flex-row items-stretch w-full">
      <div class="title cell px-8">Serial Number</div>
      <div class="data cell px-8">
        {{ loadcell.form10a.formSerialNumber?.name }}
      </div>

      <div class="title cell px-8">Element Resistance</div>
      <div class="data cell px-8">
        {{ calibration.resistance }}
      </div>
    </div>
    <div class="flex flex-row items-stretch w-full">
      <div class="title cell px-8">Sensing Element</div>
      <div class="data cell px-8">
        {{ getSensingElementText(calibration?.sensingElement) }}
      </div>

      <div class="title cell px-8">Sensitivity at WLL</div>
      <div class="data cell px-8">
        {{ calibration.output }}
      </div>
    </div>
    <div class="flex flex-row items-stretch w-full">
      <div class="title cell px-8">Working Load Limit</div>
      <div class="data cell px-8">
        {{ calibration.swl }}
      </div>

      <div class="title cell px-8">Average Error</div>
      <div class="data cell px-8">{{ getAverageError().toFixed(2) + "%" }}</div>
    </div>
  </div>

  <div
    class="flex flex-col justify-between"
  >
    <div class="results-section">
      <ng-container *ngIf="!toggleAlternateCertificate">
        <!-- Loadcell Details -->
        <div class="flex flex-col loadcell-details-container my-16 w-full">
          <p class=" mb-4">Test Machine Details</p>

          <div class="flex flex-row items-stretch w-full">
            <div class="top manufacturer-title cell px-8">Test Machine</div>
            <div class="top manufacturer-data cell px-8">
              {{ getMachineRatingText(calibration?.machineRating) }}
            </div>
          </div>

          <ng-container *ngFor="let equipment of calibration.equipmentList">
            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8">Machine Type</div>
              <div class="data cell px-8">
                {{ equipment.machine?.name }}
              </div>
              <div class="title cell px-8">Serial Number</div>
              <div class="data cell px-8">
                {{ equipment.machine?.serialNumber }}
              </div>
            </div>

            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8">Calibrated to</div>
              <div class="data cell px-8">
                {{ equipment.machine?.isoStandard }}
              </div>
              <div class="title cell px-8">Certificate Number</div>
              <div class="data cell px-8">
                {{ equipment.machine?.certificateNumber }}
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Electrical Equipment -->
        <ng-container *ngIf="calibration?.electricalEquipment && !calibration?.hideElectricalEquipmentOnCert">
          <div
            class="flex flex-col loadcell-details-container my-16 w-full"
          >
            <p class=" mb-4">Electrical Equipment Details</p>

            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8">Device</div>
              <div class="title cell px-8">Manufacturer</div>
              <div class="title cell px-8">Model Number</div>
              <div class="title cell px-8">Serial Number</div>
            </div>

            <div class="flex flex-row items-stretch w-full">
              <div class="data cell px-8">
                {{ calibration?.electricalEquipment?.name }}
              </div>
              <div class="data cell px-8">
                {{ calibration?.electricalEquipment?.manufacturer }}
              </div>
              <div class="data cell px-8">
                {{ calibration?.electricalEquipment?.modelNumber }}
              </div>
              <div class="data cell px-8">
                {{ calibration?.electricalEquipment?.serialNumber }}
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Loadcell Details -->
        <div class="flex flex-col loadcell-details-container my-16 w-full">
          <p class=" mb-4">Certified Readings</p>

          <div class="flex black cell justify-center w-full">
            {{
              "Loadcell Readings" +
                (calibration?.measurementResponse?.measurementDescription
                  ? " (" +
                    calibration?.measurementResponse?.measurementDescription +
                    ")"
                  : "")
            }}
          </div>

          <div class="flex flex-row items-stretch w-full">
            <div class="title cell px-8 w-[34%]">
              {{
                "Test Machine" +
                  (calibration?.testMachineMeasurementResponse
                    ?.measurementDescription
                    ? " (" +
                      calibration?.testMachineMeasurementResponse
                        ?.measurementDescription +
                      ")"
                    : "")
              }}
            </div>
            <div class="title cell px-8 w-[34%]">Desired</div>
            <div *ngIf="calibration?.includeRun1" class="title cell px-8 w-[34%]">
              Run 1
            </div>
            <div *ngIf="calibration?.includeRun2" class="title cell px-8 w-[34%]">
              Run 2
            </div>
            <div *ngIf="calibration?.includeRun3" class="title cell px-8 w-[34%]">
              Run 3
            </div>
            <div *ngIf="calibration?.includeRun4" class="title cell px-8 w-[34%]">
              Run 4
            </div>
            <div *ngIf="calibration?.includeRun5" class="title cell px-8 w-[34%]">
              Run 5
            </div>
            <div class="title cell px-8 w-[34%]">Error</div>
          </div>

          <div
            *ngFor="let result of calibration.resultList"
            class="flex flex-row items-stretch w-full"
          >
            <div class="data cell px-8">
              {{ getScaledValue(result.machineReadings, calibration) }}
            </div>

            <div class="data cell px-8">
              {{ getScaledValue(result.desired, calibration) }}
            </div>

            <div *ngIf="calibration?.includeRun1" class="data cell px-8">
              {{
                calibration.includeRun1
                  ? getScaledValue(result.run1, calibration)
                  : ""
              }}
            </div>

            <div *ngIf="calibration?.includeRun2" class="data cell px-8">
              {{
                calibration.includeRun2
                  ? getScaledValue(result.run2, calibration)
                  : ""
              }}
            </div>

            <div *ngIf="calibration?.includeRun3" class="data cell px-8">
              {{
                calibration.includeRun3
                  ? getScaledValue(result.run3, calibration)
                  : ""
              }}
            </div>

            <div *ngIf="calibration?.includeRun4" class="data cell px-8">
              {{
                calibration.includeRun4
                  ? getScaledValue(result.run4, calibration)
                  : ""
              }}
            </div>

            <div *ngIf="calibration?.includeRun5" class="data cell px-8">
              {{
                calibration.includeRun5
                  ? getScaledValue(result.run5, calibration)
                  : ""
              }}
            </div>

            <div class="data cell px-8">
              {{
                calibration.includeError
                  ? (result.error ?? 0).toFixed(2) + "%"
                  : ""
              }}
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="toggleAlternateCertificate">
        <!-- Machine Details -->
        <div class="flex flex-col loadcell-details-container my-16 w-full">
          <p class=" mb-4">Test Machine Details</p>

          <div class="flex flex-row items-stretch w-full">
            <div class="top manufacturer-title cell px-8">Test Machine</div>
            <div class="top manufacturer-data cell px-8">
              {{ getMachineRatingText(calibration?.additionalMachineRating) }}
            </div>
          </div>

          <ng-container
            *ngFor="let equipment of calibration.additionalEquipmentList"
          >
            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8">Machine Type</div>
              <div class="data cell px-8">
                {{ equipment.machine?.name }}
              </div>
              <div class="title cell px-8">Serial Number</div>
              <div class="data cell px-8">
                {{ equipment.machine?.serialNumber }}
              </div>
            </div>

            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8">Calibrated to</div>
              <div class="data cell px-8">
                {{ equipment.machine?.isoStandard }}
              </div>
              <div class="title cell px-8">Certificate Number</div>
              <div class="data cell px-8">
                {{ equipment.machine?.certificateNumber }}
              </div>
            </div>
          </ng-container>
        </div>

        <!-- Electrical Equipment -->
        <ng-container *ngIf="calibration?.additionalElectricalEquipment && !calibration?.hideAdditionalElectricalEquipmentOnCert">
          <div
            class="flex flex-col loadcell-details-container my-16 w-full"
          >
            <p class=" mb-4">Electrical Equipment Details</p>

            <div class="flex flex-row items-stretch w-full">
              <div class="title cell px-8">Device</div>
              <div class="title cell px-8">Manufacturer</div>
              <div class="title cell px-8">Model Number</div>
              <div class="title cell px-8">Serial Number</div>
            </div>

            <div class="flex flex-row items-stretch w-full">
              <div class="data cell px-8">
                {{ calibration?.additionalElectricalEquipment?.name }}
              </div>
              <div class="data cell px-8">
                {{ calibration?.additionalElectricalEquipment?.manufacturer }}
              </div>
              <div class="data cell px-8">
                {{ calibration?.additionalElectricalEquipment?.modelNumber }}
              </div>
              <div class="data cell px-8">
                {{ calibration?.additionalElectricalEquipment?.serialNumber }}
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Loadcell Details -->
        <div class="flex flex-col loadcell-details-container my-16 w-full">
          <p class=" mb-4">Certified Readings</p>

          <div class="flex black cell justify-center w-full">
            {{
              "Loadcell Readings" +
                (calibration?.additionalMeasurementResponse
                  ?.measurementDescription
                  ? " (" +
                    calibration?.additionalMeasurementResponse
                      ?.measurementDescription +
                    ")"
                  : "")
            }}
          </div>

          <div class="flex flex-row items-stretch w-full">
            <div class="title cell px-8 w-[34%]">
              {{
                "Test Machine" +
                  (calibration?.additionalTestMachineMeasurementResponse
                    ?.measurementDescription
                    ? " (" +
                      calibration?.additionalTestMachineMeasurementResponse
                        ?.measurementDescription +
                      ")"
                    : "")
              }}
            </div>
            <div class="title cell px-8 w-[34%]">Desired</div>
            <div
              *ngIf="calibration?.additionalIncludeRun1"
              class="title cell px-8 w-[34%]"
            >
              Run 1
            </div>
            <div
              *ngIf="calibration?.additionalIncludeRun2"
              class="title cell px-8 w-[34%]"
            >
              Run 2
            </div>
            <div
              *ngIf="calibration?.additionalIncludeRun3"
              class="title cell px-8 w-[34%]"
            >
              Run 3
            </div>
            <div
              *ngIf="calibration?.additionalIncludeRun4"
              class="title cell px-8 w-[34%]"
            >
              Run 4
            </div>
            <div
              *ngIf="calibration?.additionalIncludeRun5"
              class="title cell px-8 w-[34%]"
            >
              Run 5
            </div>
            <div class="title cell px-8 w-[34%]">Error</div>
          </div>

          <div
            *ngFor="let result of calibration.additionalResultList"
            class="flex flex-row items-stretch w-full"
          >
            <div class="data cell px-8">
              {{ getScaledValue(result.machineReadings, calibration, true) }}
            </div>

            <div class="data cell px-8">
              {{ getScaledValue(result.desired, calibration, true) }}
            </div>

            <div
              *ngIf="calibration?.additionalIncludeRun1"
              class="data cell px-8"
            >
              {{
                calibration.additionalIncludeRun1
                  ? getScaledValue(result.run1, calibration, true)
                  : ""
              }}
            </div>
            <div
              *ngIf="calibration?.additionalIncludeRun2"
              class="data cell px-8"
            >
              {{
                calibration.additionalIncludeRun2
                  ? getScaledValue(result.run2, calibration, true)
                  : ""
              }}
            </div>

            <div
              *ngIf="calibration?.additionalIncludeRun3"
              class="data cell px-8"
            >
              {{
                calibration.additionalIncludeRun3
                  ? getScaledValue(result.run3, calibration, true)
                  : ""
              }}
            </div>

            <div
              *ngIf="calibration?.additionalIncludeRun4"
              class="data cell px-8"
            >
              {{
                calibration.additionalIncludeRun4
                  ? getScaledValue(result.run4, calibration, true)
                  : ""
              }}
            </div>

            <div
              *ngIf="calibration?.additionalIncludeRun5"
              class="data cell px-8"
            >
              {{
                calibration.additionalIncludeRun5
                  ? getScaledValue(result.run5, calibration, true)
                  : ""
              }}
            </div>

            <div class="data cell px-8">
              {{
                calibration.includeError
                  ? (result.error ?? 0).toFixed(2) + "%"
                  : ""
              }}
            </div>
          </div>
        </div>
      </ng-container>

      <div class="flex flex-col loadcell-details-container my-16 w-full">
        <p class=" mb-4">
          The uncertainties are for a confidence probability of not less than
          95%
        </p>
      </div>
    </div>

    <div class="mt-6">
      <div class="flex flex-col w-full avoid-break mt-8">
        <p class="">Certifying Engineer:</p>
        <div class="flex flex-row mx-16 w-50">
          <img src="{{ calibration?.signature }}" />
        </div>
        <p class="">{{ calibration?.employeeName }}</p>
      </div>

      <div>
        <img src="../../../assets/dlm-images/dlm/dlm-footer-grey.png" />
      </div>
    </div>
  </div>
</div>

<!-- Print stuff -->

<div id="print-header" style="display: none;">
  <img class="pt-32 px-32" src="../../../assets/dlm-images/dlm/dlm-header.png" />
</div>

<div id="print-footer" style="display: none;">
  <img class="p-32" src="../../../assets/dlm-images/dlm/dlm-footer-grey.png" />
</div>
